<template>
  <div class="mt-2">
    <strong>{{ firstSentence }}. </strong>{{ remainingSentences }}
    <p v-if="!['JOINING_TOUR', 'PRIVATE_BOAT_TOUR'].includes(listingType)">
      <span v-if="originDescription">{{ originDescription }}</span>
      <span v-if="destinationDescription">{{ destinationDescription }}</span>
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  seoDescription: {
    type: String,
    required: true
  },
  origin: {
    type: String,
    required: true
  },
  destination: {
    type: String,
    required: true
  },
  listingType: {
    type: String,
    required: true
  }
});

// Split the description to highlight the first sentence
const firstSentence = computed(() => {
  const sentences = props.seoDescription.split('.');
  return sentences[0] || '';
});

const remainingSentences = computed(() => {
  const sentences = props.seoDescription.split('.');
  return sentences.length > 1 ? sentences.slice(1).join('.') : '';
});

// Generate origin description based on origin code
const originDescription = computed(() => {
  if (props.origin === 'PPS' && props.listingType.includes('PRIVATE')) {
    return 'You can choose to be pickup at your hotel in Puerto Princesa City Center or directly at Puerto Princesa International Airport and ';
  } else if (props.origin === 'SVC' && props.listingType.includes('PRIVATE')) {
    return 'You can choose to be pickup at your hotel in San Vicente Center or directly at San Vicente Airport(SWL) and ';
  } else if (props.origin === 'ELN' && props.listingType.includes('PRIVATE')) {
    return 'You can choose to be pickup at your hotel in El Nido and ';
  } else if (props.origin === 'PBT' && props.listingType.includes('PRIVATE')) {
    return 'Direct pickup at your hotel in Port Barton and ';
  } else if (props.origin === 'SAB' && props.listingType.includes('PRIVATE')) {
    return 'Direct pickup at your hotel near Sabang Beach Area(e.g Four Points by Sheraton Puerto Princesa, Daluyon Mountain and Beach Resort, etc.).';
  }
  return '';
});

// Generate destination description based on destination code
const destinationDescription = computed(() => {
  if (props.destination === 'PPS') {
    return 'to be drop off at your hotel in Puerto Princesa City Center or directly at Puerto Princesa International Airport';
  } else if (props.destination === 'SVC') {
    return 'to be drop off at your hotel in San Vicente Center or directly at San Vicente Airport(SWL)';
  } else if (props.destination === 'ELN' && props.listingType.includes('PRIVATE')) {
    return 'to be drop off directly in your hotel in El Nido.';
  } else if (props.destination === 'PBT' && props.listingType.includes('PRIVATE')) {
    return 'directly drop off at your hotel in Port Barton.';
  } else if (props.destination === 'SAB' && props.listingType.includes('PRIVATE')) {
    return 'directly drop off at your hotel near Sabang Beach Area(e.g Four Points by Sheraton Puerto Princesa, Daluyon Mountain and Beach Resort, etc.).';
  }
  return '';
});
</script> 